import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "@/hooks/useAuth";
import "@/components/AppShell/AppShell.scss";

function navLinkClassName({ isActive }: { isActive: boolean }): string {
  return isActive ? "app-shell__link app-shell__link--active" : "app-shell__link";
}

function AppShell() {
  const { t } = useTranslation();
  const { session, signOut } = useAuth();
  const navigate = useNavigate();

  if (!session) {
    return null;
  }

  const isAdmin = session.role === "ADMIN";

  const handleSignOut = () => {
    signOut();
    navigate("/signin", { replace: true });
  };

  return (
    <div className="app-shell">
      <nav className="app-shell__sidebar">
        <div className="app-shell__brand">{t("app.title")}</div>

        <ul className="app-shell__nav">
          {isAdmin ? (
            <>
              <li>
                <NavLink to="/companies" end className={navLinkClassName}>
                  {t("appShell.nav.companies")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/properties" end className={navLinkClassName}>
                  {t("appShell.nav.properties")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/extras" className={navLinkClassName}>
                  {t("appShell.nav.extras")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/places" className={navLinkClassName}>
                  {t("appShell.nav.places")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/users" className={navLinkClassName}>
                  {t("appShell.nav.users")}
                </NavLink>
              </li>
            </>
          ) : (
            <>
              <li>
                <NavLink to="/" end className={navLinkClassName}>
                  {t("appShell.nav.dashboard")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/my-properties" className={navLinkClassName}>
                  {t("appShell.nav.myProperties")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/my-bookings" className={navLinkClassName}>
                  {t("appShell.nav.myBookings")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/users/new" className={navLinkClassName}>
                  {t("appShell.nav.createUser")}
                </NavLink>
              </li>
            </>
          )}
          <li>
            <NavLink to="/profile" className={navLinkClassName}>
              {t("appShell.nav.profile")}
            </NavLink>
          </li>
        </ul>

        <div className="app-shell__footer">
          <p className="app-shell__email">{session.email}</p>
          <button type="button" onClick={handleSignOut}>
            {t("appShell.signOut")}
          </button>
        </div>
      </nav>

      <main className="app-shell__content">
        <Outlet />
      </main>
    </div>
  );
}

export default AppShell;
